import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Participants } from '../shared/models/participants';
import { ManageUserRoleService } from '../shared/services/manage-user-role.service';
import { UserRole } from '../shared/models/user-role';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { SnackbarService } from '../shared/services/snackbar.service';

@Component({
    selector: 'xp-manage-roles',
    templateUrl: './manage-roles.component.html',
    styleUrl: './manage-roles.component.scss'
})
export class ManageRolesComponent implements OnInit {

    manageRolesDisplayedColumns: string[] = ["roleId", "actionstepRole", "description", "request", "partnerApprove", "accountsApprove", "viewAuditLog", "manageRoles"];
    dataSource: UserRole[] = [];
    managerRolesForm!: FormGroup;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: { data: UserRole[], juri: string },
        private manageUserRoleService: ManageUserRoleService,
        public dialogRef: MatDialogRef<ManageRolesComponent>,
        private formBuilder: FormBuilder,
        private snackbarService: SnackbarService
    ) { }

    ngOnInit() {
        this.dataSource = this.data.data;

        // Initialize the FormArray with FormGroups for each row
        this.managerRolesForm = this.formBuilder.group({
            roles: this.formBuilder.array(this.dataSource.map(role => this.createRoleFormGroup(role)))
        });
    }

    createRoleFormGroup(role: UserRole): FormGroup {
        var form = this.formBuilder.group({
            roleId: [{ value: role.roleId, disabled: true }],  // Read-only field
            actionstepRole: [{ value: role.actionstepRole, disabled: true }],  // Read-only field
            description: [{ value: role.description, disabled: true }],  // Read-only field
            request: [role.request],
            partnerApprove: [role.partnerApprove],
            accountsApprove: [role.accountsApprove],
            viewAuditLog: [role.viewAuditLog],
            manageRoles: [role.manageRoles],
            juridiction: this.data.juri,
        });

        if (role.actionstepRole == 'Administrator' && role.manageRoles) {
            form.get('manageRoles')!.disable()
        }

        return form;
    }

    async onSubmit() {
        // Capture the form values
        if (this.managerRolesForm.valid) {
            const formValues: UserRole[] = this.managerRolesForm.getRawValue().roles;
            const partnerApproveValue = formValues[0]?.partnerApprove;
            this.manageUserRoleService.setPartnerApprove(partnerApproveValue);

            try {
                const res = await this.manageUserRoleService.UpdatePermissionsOfRoles(formValues);
                if (res) {
                    this.snackbarService.successSnackBar("Updated Roles Successfully.");
                    this.dialogRef.close(true);
                }
            } catch (error) {
                this.snackbarService.errorSnackBar("Failed to update roles. Please try again.");
            }
        }
    }
    get rolesFormArray() {
        return this.managerRolesForm.get('roles') as FormArray;
    }

}
